export default "__VITE_ASSET__DktMJlYR__"